import { Box, Stack, Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

import { usePresenceStore } from '#features/presence/model/presenceStore';
import { Button } from '#features/ui';
import { TierAvatars } from '#features/voice/components/SessionVoiceTier/TierAvatars';
import type { RosterVoiceMember } from '#features/voice/utils/mergeRosterVoice';

export const Route = createFileRoute('/{-$locale}/_layout/preview/voice-avatars')({
  component: VoiceAvatarsPreview,
  ssr: false,
});

const members: RosterVoiceMember[] = ['Артём', 'Nova', 'Lily', 'Salt'].map((name, index) => ({
  userId: `00000000-0000-4000-8000-00000000000${index}`,
  name,
  avatar: null,
  isHost: index === 0,
  inVoice: true,
  speaking: index === 0,
  muted: false,
}));

function VoiceAvatarsPreview() {
  return (
    <Stack p={6} gap={6}>
      <Text textStyle="title">Индикатор речи: реальные аватары виджета</Text>
      <Button
        onClick={() =>
          usePresenceStore
            .getState()
            .applyStatuses(members.map(({ userId }) => ({ userId, status: 'ONLINE' })))
        }
      >
        Показать тестовый статус «в сети»
      </Button>
      <Box bg="bg.surface" p={4} borderRadius="lg">
        <Stack gap={4}>
          <Box data-testid="speaking-online">
            <Text mb={3}>Говорит: только зелёное кольцо</Text>
            <TierAvatars
              members={[{ ...members[0], avatar: '/preview/teamplay-icons/player-profiles.png' }]}
            />
          </Box>
          <Box data-testid="listening-online">
            <Text mb={3}>Слушает: только фиолетовое кольцо</Text>
            <TierAvatars members={[{ ...members[0], speaking: false }]} />
          </Box>
          <Box data-testid="outside-voice-online">
            <Text mb={3}>Вне голоса: обычная точка «в сети»</Text>
            <TierAvatars members={[{ ...members[0], speaking: false, inVoice: false }]} />
          </Box>
          <Text>Говорит, слушает и дополнительные участники</Text>
          <TierAvatars members={members} maxCircles={3} />
          <Text>Discord / без голосового индикатора: обычные статусы</Text>
          <TierAvatars members={members} showVoice={false} maxCircles={3} />
        </Stack>
      </Box>
    </Stack>
  );
}
